import { render, staticRenderFns } from "./AddStockOpname.vue?vue&type=template&id=3b960826&"
import script from "./AddStockOpname.vue?vue&type=script&lang=js&"
export * from "./AddStockOpname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports